import React from 'react';

const BirthDate = ({ birthDate }) => {
  const formattedDate = new Date(birthDate).toLocaleDateString('nl-BE');

  return <p>{formattedDate}</p>;
};

export default BirthDate;
